import { WithGlobalCss } from "@sgwt-widget/core";
import { Component, h } from "preact";

interface IProps {
  mailTo: string;
  subject: string;
  bodyMessage: string;
}

export const DealListEmail = class extends Component<IProps> {
  public constructor() {
    super();
  }

  public render(): JSX.Element {
    return (
      <WithGlobalCss>
        <div>
          <button
            class="btn btn-default"
            style="margin-left: 15px"
            onClick={() => this.MailToClick(this)}
          >
            Mail to MACC
          </button>
        </div>
      </WithGlobalCss>
    );
  }
  private MailToClick(event: any) {
    const mailTo = this.props.mailTo;
    const subject = this.props.subject;
    const bodyMessage = this.props.bodyMessage;
    window.location.href = this.createMailtoLink(mailTo, subject, bodyMessage);
  }

  private readonly createMailtoLink = (
    email: any,
    subject: any,
    bodyMessage: any
  ) => {
    return `mailto:${email}?subject=${subject}&body=${bodyMessage}`;
  };
};
